import { CoreType } from "../../Core/Core.Interfaces";
import { GenericTableSchemaInterface } from "../../Table/Table.Interfaces";
import { VarKey } from "../../Variables/Generated/VarKey.Data";

export const GMBSessionTable: GenericTableSchemaInterface = {
  id: "gmb-session",
  name: "GMB Session",
  description: "This table records when a user has a GMB Session",
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: "Name",
      variable: VarKey.UserName
    },
    c02: {
      name: "Store Id",
      variable: VarKey.LocationFMSId
    },
    c03: {
      name: "Store Google Place Id"
    },
    c04: {
      name: "Store FMS Integration Id",
      variable: VarKey.LocationFMSIntegrationId
    },
    c05: {
      name: "Store FMS Type",
      variable: VarKey.LocationFMSType
    },
    c06: {
      name: "Minutes since last interaction"
    }
  }
};
